export const ARTEFACT_FRAME_URL = "/artefact-frame.html";
